<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal id="rrc-modal" size="lg" title="RRC Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <form action="" enctype="multipart/form-data" files="true" role="form">
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="deed_number">Deed Number <span class="c-required">*</span></label>
              <input type="text" v-model="rrc.deed_number" v-validate="{ required: true }" id="deed_number" name="deed_number" placeholder="Deed number" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Deed number is required</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="deed_date">Deed Date <span class="c-required">*</span></label>
              <datepicker v-model="rrc.deed_date" v-validate="'required'" id="deed_date" name="deed_date" :format="customDeedDate" placeholder="Deed Date"></datepicker>
              <div class="text-danger" v-if="errors.has('deed_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">Deed date required</div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="mouza">Mouza <span class="c-required">*</span></label>
              <input type="text" v-model="rrc.mouza" v-validate="{ required: true }" id="mouza" name="mouza" placeholder="Mouza" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Mouza is required</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="upazila">Upazila <span class="c-required">*</span></label>
              <input type="text" v-model="rrc.upazila" v-validate="{ required: true }" id="upazila" name="upazila" placeholder="Upazila" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Upazila is required</div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="sub_reg_office">Sub Reg Office <span class="c-required">*</span></label>
              <input type="text" v-model="rrc.sub_reg_office"  v-validate="{ required: true }" id="sub_reg_office" name="sub_reg_office" placeholder="Sub reg office" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Upazila is required</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="reg_fee">Reg Fee</label>
              <input type="number" v-model="rrc.reg_fee"  v-validate="{ regex: /^[0-9]*(?:\.[0-9]{0,5})?$/ }" id="reg_fee" name="reg_fee" placeholder="Reg fee" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Reg fee is required</div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="land_quantity">Land Quantity</label>
              <input type="number" v-model="rrc.land_quantity"  v-validate="{ max: 16, regex: /^[0-9]*(?:\.[0-9]{0,5})?$/  }" id="land_quantity" name="land_quantity" placeholder="Land quantity" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Land quantity is invalid</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="land_type_id">Land Type <span class="c-required">*</span></label>
              <select v-model="rrc.land_type_id" v-validate="'required'" class="form-control form-control-sm" name="land_type_id" id="land_type_id">
                <option selected :value="''">Select a land type</option>
                <option v-for="(land_type, index) in land_types" v-bind:value="land_type.id" :key="index">{{ land_type.land_type_desc }}</option>
              </select>
              <div class="invalid-feedback">Land type is required</div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="land_value">Land Value <span class="c-required">*</span></label>
              <input type="number" v-model="rrc.land_value" v-validate="{ max: 16, regex: /^[0-9]*(?:\.[0-9]{0,5})?$/  }" id="land_value" name="land_value" placeholder="Land value" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Land value is required</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <label class="col-form-label col-form-label-sm" for="replacement_value">Replacement Value <span class="c-required">*</span></label>
              <input type="number" v-model="rrc.replacement_value" v-validate="{ max: 16, regex: /^[0-9]*(?:\.[0-9]{0,5})?$/  }" id="replacement_value" name="replacement_value" placeholder="Replacement value" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Replacement value is required</div>
            </div>
          </div>
          <b-button v-if="!this.btn_edit" class="form-control-sm mr-2 mt-3" size="sm" variant="success" @click.prevent="save">Save</b-button>
          <b-button v-if="this.btn_edit" class="form-control-sm mr-2 mt-3" size="sm" variant="warning" @click.prevent="update">Update</b-button>
          <b-button class="form-control-sm mt-3"  size="sm" variant="danger" @click="$bvModal.hide('rrc-modal')">Cancel</b-button>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "rrcModal",
  props: ["rrc", "btn_edit"],
  components: {Datepicker},
  data() {
    return {
      land_types: [],
      validation_errors: {},
      show: false
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    customDeedDate(date) {
      this.rrc.deed_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    getCodes() {
      http.get("api/rrc/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.land_types = data.land_types;
        }
      });
    },
    save() {
      this.rrc.ses_id = this.$route.params.ses_id;
      this.$validator.validate().then(valid => {
        if (valid) {
          http
              .post("api/rrcs", this.rrc )
              .then(response => {
                if (!response.error) {
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$bvModal.hide("rrc-modal");
                  this.$emit("getSesRrc");
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
              .put("api/rrcs/" + this.rrc.id, this.rrc )
              .then(response => {
                if (!response.error) {
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  })
                  this.$bvModal.hide("rrc-modal");
                  this.$emit("getSesRrc");
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
<style lang="scss">
.custom-select {
  color: #6c757d !important;
}
.c-required{
  color: red;
}
.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}
</style>
